<template>
  <div
    class="w-3/4 max-w-[300px] mx-auto rounded-lg bg-gray-100 border-2 border-gray-300 text-gray-500 font-medium text-sm text-center"
  >
    <div class="leading-tight m-2"><slot name="default"></slot></div>
    <div class="mx-2">
      <IonSkeletonText class="w-full rounded"></IonSkeletonText>
      <IonSkeletonText class="w-full rounded"></IonSkeletonText>
      <IonSkeletonText class="w-full rounded"></IonSkeletonText>
    </div>
    <div class="h-[40px] mt-4 border-t-2 border-gray-300 flex *:flex *:justify-center *:items-center *:w-1/2 *:h-full">
      <div class="border-r-2 border-gray-300 text-blue-300">Don't Allow</div>
      <div class="font-bold text-blue-500"><slot name="allow">Allow</slot></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonSkeletonText } from '@ionic/vue';
</script>

<style scoped></style>
